/** Dev-only call diagnostics; no-op in production builds. */
export const CALL_DEBUG = process.env.NODE_ENV === "development";

export function callDebugLog(...args) {
  if (CALL_DEBUG) {
    console.log(...args);
  }
}
